import EditFeedLightBoxHeader from './EditFeedLightBoxHeader'
import EditFeedLightboxFooter from './EditFeedLightboxFooter'
import EditFeedLightBoxContent from './EditFeedLightBoxContent'
import StateComponent from '../../../../../../js/StateComponent'
import {bindActionCreators} from 'redux'
import {connect} from '../../../../../../js/redux/utils'
import {getLightBoxType, isEditLightBoxDataChanged, isEditLightBoxShown, isEditLightBoxSubmitEnabled} from '../selectors'
import {closeICalLightBox, createFeed, editFeed, saveFeedSettings} from '../actions'
import LightBox from '../../../../../../js/components/LightBox'
import $ from '../../../../../../js/alias/jquery'
import {isUserActionLoading} from '../../../selectors'

class EditFeedLightBox extends StateComponent {
    constructor({
        saveFeedSettings,
        closeICalLightBox,
    }) {
        super()

        this.actions = {
            saveFeedSettings,
            closeICalLightBox,
        }

        this.state = {
            type: null,
            shown: false,
            submitEnabled: true,
            dataChanged: false,
            loading: false,
        }

        this.onStatePropertyChanged('type', type => {
            this.header.setState({type})
            this.footer.setState({type})
        })

        this.onStatePropertyChanged('shown', shown => this._toggle(shown))
        this.onStatePropertyChanged('submitEnabled', submitEnabled => this.footer.setState({submitEnabled}))
        this.onStatePropertyChanged('dataChanged', dataChanged => this.lightBox.dataChanged = dataChanged)
        this.onStatePropertyChanged('loading', loading => this.footer.setState({loading}))
    }

    init() {
        this.header = new EditFeedLightBoxHeader()
        this.footer = new EditFeedLightboxFooter({
            onSubmitButtonClick: this.actions.saveFeedSettings,
            onCancelButtonClick: this.actions.closeICalLightBox,
        })
        this.content = new EditFeedLightBoxContent()

        this.lightBox = new LightBox(
            $('body'),
            {
                cancel_confirmation_message_key: 'lightbox.cancel_changes',
            }).init({
            id: 'editFeedLightBox',
            header: this.header,
            content: this.content,
            footer: this.footer,
            classNames: 'editFeedLightBox iCalLightBox',
            cancelCallback: this.actions.closeICalLightBox,
        })

        return this
    }

    _toggle(isShown) {
        this.lightBox.toggle(isShown)
        if (isShown) {
            this.content.onShow()
        }
    }
}

export default connect(
    state => ({
        submitEnabled: isEditLightBoxSubmitEnabled(state),
        type: getLightBoxType(state),
        shown: isEditLightBoxShown(state),
        dataChanged: isEditLightBoxDataChanged(state),
        loading: isUserActionLoading(state),
    }),
    dispatch => bindActionCreators({
        saveFeedSettings,
        closeICalLightBox,
    }, dispatch)
)(EditFeedLightBox)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/lightbox/edit/EditFeedLightBox.js